import { formatDateTime } from '../../common/formatters.ts';

export const getFormattedServerDate = (date: string) => {
  return `${formatDateTime(date)}`;
};
